import en from './en.mjs'

export default Object.freeze({
  ...en,
  'static.common.home': 'Happy Pets로 돌아가기',
  'static.common.open': '이 경험 열기',
  'static.common.body': '나만의 속도로 경험하고 발견한 내용을 Happy Pets 동반자와의 대화에서 더 탐색해 보세요.',
  'static.common.safetyreflection': '자기 탐색, 성찰과 오락을 위한 경험입니다.',
  'static.common.safetymedical': '이 자가 점검은 진단이 아닙니다. 건강이나 안전이 걱정되면 자격을 갖춘 전문가에게 문의하세요.',
  'static.common.safetycareer': '자기 탐색을 위한 경험이며 전문적인 진로 상담을 대신하지 않습니다.',
  'static.common.safetyiq': '자기 탐색을 위한 추론 과제로 실제 IQ를 확정하지 않습니다.',
  'static.feature.aicompanion.title': '일상과 함께 성장하는 AI 동반자',
  'static.feature.aicompanion.description': '일상의 순간을 기억하고 가볍게 도우며 위젯으로 늘 가까이 있는 가상 반려동물을 키우세요.',
  'static.feature.aitarot.title': '부드러운 성찰을 위한 AI 타로',
  'static.feature.aitarot.description': '타로 카드를 성찰과 새로운 관점, 다음 한 걸음을 위한 창의적인 힌트로 사용하세요.',
  'static.feature.mbti.title': 'AI 동반자와 함께하는 MBTI 성격 테스트',
  'static.feature.mbti.description': '성격 선호, 소통, 강점과 성장 방향을 AI 동반자와 함께 탐색하세요.',
  'static.feature.mindscope.title': 'Mind Scope 자기 발견 테스트',
  'static.feature.mindscope.description': '성격, 추론, 진로, 관계와 감정 테스트를 한곳에서 만나세요.',
  'static.feature.sbti.title': '재미있는 자기 발견을 위한 SBTI 테스트',
  'static.feature.sbti.description': '다섯 가지 재미있는 차원에서 나의 사회적 스타일을 알아봅니다.',
  'static.feature.funny.title': '친구와 공유하는 재미있는 성격 테스트',
  'static.feature.funny.description': '가벼운 성격 경험을 하고 친구와 결과를 비교해 보세요.',
  'static.feature.iq.title': '인지 도전을 위한 IQ 추론 테스트',
  'static.feature.iq.description': '시각적·비언어적 패턴을 푸는 구조화된 추론 과제입니다.',
  'static.feature.scl90.title': '개인 성찰을 위한 SCL-90 자가 점검',
  'static.feature.scl90.description': '구조화된 항목으로 패턴을 살피고 필요하면 전문가에게 물어볼 내용을 정리하세요.',
  'static.feature.holland.title': '자기 탐색을 위한 홀랜드 직업 흥미 테스트',
  'static.feature.holland.description': '여섯 가지 흥미 영역에서 나에게 맞을 수 있는 활동과 업무 환경을 생각해 봅니다.',
  'static.feature.psychage.title': '개인 성찰을 위한 심리 나이 테스트',
  'static.feature.psychage.description': '재미있는 질문으로 태도, 습관과 일상에 접근하는 방식을 돌아봅니다.',
  'static.feature.attachment.title': '관계 성찰을 위한 애착 유형 테스트',
  'static.feature.attachment.description': '친밀감, 신뢰, 안정감과 독립성을 돌아봅니다.',
  'static.feature.temperament.title': '자기 발견을 위한 기질 테스트',
  'static.feature.temperament.description': '감정 강도, 속도, 적응성과 일상 반응을 탐색합니다.',
  'static.feature.eq.title': '성찰을 위한 감성 지능 테스트',
  'static.feature.eq.description': '감정 인식, 조절, 공감과 소통을 돌아봅니다.',
  'static.help.title': 'Happy Pets 도움말 센터',
  'static.help.description': '공동 양육, 초대, 광고, 반려동물 관리와 자주 묻는 질문을 안내합니다.',
  'static.help.intro': 'Happy Pets의 자주 묻는 질문을 빠르게 확인하세요.',
  'static.help.sections': [
    { title: '친구와 함께 반려동물을 키우고 싶어요.', body: 'Pet Farm, 반려동물 메뉴 또는 오른쪽 위 작업 메뉴에서 초대하세요. 친구는 링크, 공동 양육 코드 또는 앱 내 요청으로 참여할 수 있습니다.' },
    { title: '광고 영상이 로드되지 않아요.', body: '네트워크를 확인하고 앱을 재시작하고 캐시를 지운 뒤 최신 버전으로 업데이트하세요. 계속되면 고객 지원에 문의하세요.' },
    { title: '공동 양육이 무엇인가요?', body: '여러 사용자가 같은 가상 반려동물을 돌보며 역할과 교감, 특별 보상을 공유하는 기능입니다.' },
    { title: '이름이나 호칭은 어떻게 바꾸나요?', body: '프로필에서 설정을 열어 반려동물 이름 또는 주인 이름을 수정하고 저장하세요. 변경 대기 시간이 있을 수 있습니다.' }
  ],
  'static.privacy.title': 'Happy Pets 개인정보 처리방침',
  'static.privacy.description': 'Happy Pets가 수집하는 정보, 이용과 보호 방법, 문의처를 안내합니다.',
  'static.privacy.effective': '시행일: 2025년 4월 7일',
  'static.privacy.intro': 'Happy Pets는 개인정보를 소중히 여깁니다. 이 방침은 앱, 서비스 또는 웹사이트 이용 시 정보 처리 방법을 설명합니다.',
  'static.privacy.sections': [
    { title: '1. 수집 정보', body: '먹이 주기와 성장 기록 등 상호작용 데이터, 기기 및 이용 분석, 사용자가 제출한 연락처나 피드백을 수집할 수 있습니다.' },
    { title: '2. 이용 목적', body: '반려동물과 위젯 기능 제공, 품질 개선, 문제 해결, 고객 지원과 콘텐츠 개인화에 사용합니다.' },
    { title: '3. 정보 공유', body: '개인정보를 판매하지 않습니다. 서비스 운영과 유지에 필요한 경우에만 적절한 보호 의무 아래 신뢰할 수 있는 제공업체와 공유합니다.' },
    { title: '4. 보안', body: '분실, 도난과 무단 접근을 막기 위해 합리적인 보호 조치를 사용합니다.' },
    { title: '5. 이용자의 권리', body: '정보 열람이나 정정을 요청할 수 있고 happyscratchpad@gmail.com으로 계정 및 관련 데이터 삭제를 신청할 수 있습니다.' },
    { title: '6. 아동 개인정보', body: '보호자 동의 없이 13세 미만 아동을 대상으로 하지 않습니다.' },
    { title: '7. 변경', body: '방침을 업데이트할 수 있으며 중요한 변경은 이용자에게 알립니다.' },
    { title: '8. 문의', body: '개인정보 문의는 happyscratchpad@gmail.com으로 보내 주세요.' }
  ],
  'static.terms.title': 'Happy Pets 이용약관',
  'static.terms.description': '계정, 가상 아이템, 위젯, 공동 양육과 허용되는 이용에 관한 약관입니다.',
  'static.terms.effective': '시행일: 2025년 4월 7일',
  'static.terms.intro': '이 약관은 Happy Pets 접근과 이용에 적용됩니다. 서비스를 이용하면 약관에 동의하게 됩니다.',
  'static.terms.sections': [
    { title: '1. 서비스 설명', body: 'Happy Pets는 가상 반려동물 양육, 먹이 주기, 부화, 공동 양육, 위젯과 관련 경험을 제공하는 오락 서비스입니다.' },
    { title: '2. 계정', body: '일부 기능에는 계정이 필요합니다. 정확한 정보를 제공하고 계정을 안전하게 관리해야 합니다.' },
    { title: '3. 가상 아이템', body: '가상 반려동물, 아이템과 보상은 양도할 수 없고 현실의 금전적 가치가 없습니다.' },
    { title: '4. 이용 행위', body: '불법 이용, 서비스나 다른 이용자 방해, 공격적·위협적·부적절한 콘텐츠 공유를 금지합니다.' },
    { title: '5. 공동 양육', body: '친구를 초대해 반려동물을 함께 돌보고 책임과 혜택을 공유할 수 있습니다.' },
    { title: '6. 위젯', body: '홈 화면에 반려동물을 추가하고 먹이 주기, 기분 확인, 교감 기능을 사용할 수 있습니다.' },
    { title: '7. 이용 종료', body: '위반이나 남용이 있으면 접근을 일시 중지하거나 종료할 수 있습니다.' },
    { title: '8. 책임 제한', body: '서비스는 현 상태로 제공됩니다. 법이 허용하는 범위에서 이용 관련 손실에 책임지지 않습니다.' },
    { title: '9. 업데이트', body: '기능, 콘텐츠 또는 약관을 변경할 수 있습니다. 변경 후 계속 이용하면 동의한 것으로 봅니다.' },
    { title: '10. 문의', body: '문의는 happyscratchpad@gmail.com으로 보내 주세요.' }
  ]
})
